import { render, staticRenderFns } from "./BreadcrumbSeparator.vue?vue&type=template&id=345bc747&scoped=true"
import script from "./BreadcrumbSeparator.vue?vue&type=script&lang=js"
export * from "./BreadcrumbSeparator.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbSeparator.vue?vue&type=style&index=0&id=345bc747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345bc747",
  null
  
)

export default component.exports